import { createSelector } from '@reduxjs/toolkit'
import { merklebaseAPI } from 'store/api/merklebaseAPI'

const selectLiquidityTiersResult = merklebaseAPI.endpoints.getLiquidityTiers.select()

export const selectLiquidityTiersData = createSelector(
  [selectLiquidityTiersResult],
  (result) => result?.data ?? []
)

export const selectLiquidityTiersLoading = createSelector(
  [selectLiquidityTiersResult],
  (result) => result?.isLoading ?? result?.isFetching ?? false
)

export const selectLiquidityTiersFetching = createSelector(
  [selectLiquidityTiersResult],
  (result) => result?.isFetching ?? false
)
